import React from 'react';
import { steps } from '../../data/site';
export function ProcessSection() {
  return <section aria-labelledby="process-title" className="bg-forest text-cream" data-id="element-136" data-mp="gu7k0fykebm0">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28" data-id="element-137" data-mp="buuvlqs1owhb">
        <h2 id="process-title" className="max-w-2xl font-serif text-4xl font-medium leading-tight md:text-5xl" data-id="element-138" data-mp="bt1ns85p467q">
          Comment se passe une intervention
        </h2>
        <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-139" data-mp="2v84bxt1571z">
          {steps.map((step, index) => <li key={step.title} className="relative border-t border-cream/25 pt-6" data-id="element-140" data-mp="3u79f6leu58zk" data-mpi={index}>
              <span className="font-serif text-5xl text-cream/40" aria-hidden="true" data-id="element-141" data-mp="3paj5cftmj9ml">
                {index + 1}
              </span>
              <h3 className="mt-4 text-lg font-medium text-white" data-id="element-142" data-mp="3k8tpmmvgi7s6">{step.title}</h3>
              <p className="mt-2 leading-relaxed text-cream/75" data-id="element-143" data-mp="3g89shjavv461">{step.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}